module.exports = __webpack_public_path__ + "img/error-zhanweitu@2x.017fb5d7.png";